/*
 * @Author: Veto [部分隐私协议网址 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-07-01 16:08:08
 */

import YiDui from '../views/privacy/yidui';
import TongChengYeXiu from '../views/privacy/tcyx.vue';
import SuPeiTongChengJiaoYou from '../views/privacy/sptcjy.vue';

import MiYouIOS from '../views/privacy/miyou_ios';
import MiYouHW from '../views/privacy/miyou_hw';
import LiaoBeiSheJiao from '../views/privacy/liaobei';

import YeLiaoHW from '../views/privacy/yeliao_hw';
import YeLiao from '../views/privacy/yeliao';
import YeXiu from '../views/privacy/yexiu';

import MiTaoKaiMao from '../views/privacy/mitao_kaimao';
import MiTaoYunQi from '../views/privacy/mitao_yunqi';
import LiaoBan from '../views/privacy/liaoban';
import LiaoBanHaoYun from '../views/privacy/liaoban_haoyun';

import YeSeYeLiao from '../views/privacy/stage_1/ysyl';
import XiaoYuMi from '../views/privacy/stage_1/xiaoyumi';
import MoShengJiaoYou from '../views/privacy/stage_1/mosheng';
import YuMiJiaoYou from '../views/privacy/stage_1/yumijiaoyou';

import XiuSeYeLiao from '../views/privacy/stage_1/xsyl';
import XiaoShuLin from '../views/privacy/stage_1/xiaoshulin';
import LiaoBanXunYuan from '../views/privacy/stage_1/lbxy';

import MiTaoXiaoMi from '../views/privacy/stage_1/mitao_xiaomi';
import XunTa from '../views/privacy/stage_1/xunta';
import XunTaMiMi from '../views/privacy/stage_1/xunta_mimi';

import ErrorAccess from '../views/common/errorAccess.vue';


const router = {
    '/privacy-yidui': YiDui,
    // '/privacy-tcyx': TongChengYeXiu,
    '/privacy-tcyx': ErrorAccess,
    '/privacy-sptcjy': SuPeiTongChengJiaoYou,

    '/privacy-miyou': MiYouIOS,
    '/privacy-miyou-hw': MiYouHW,
    '/privacy-liaobei': LiaoBeiSheJiao,

    '/privacy-yeliao-hw': YeLiaoHW,
    '/privacy-yeliao': YeLiao,
    '/privacy-yexiu': YeXiu,

    '/privacy-mitao-kaimao': MiTaoKaiMao,
    '/privacy-mitao-yunqi': MiTaoYunQi,
    '/privacy-liaoban': LiaoBan,
    '/privacy-liaoban-haoyun': LiaoBanHaoYun,
    '/privacy-ysyl': YeSeYeLiao,
    '/privacy-xsyl': XiuSeYeLiao,

    '/privacy-xsl': XiaoShuLin,
    '/privacy-lbxy': LiaoBanXunYuan,
    '/privacy-xiaoyumi': XiaoYuMi,
    '/privacy-xiaomi-yunqi': MiTaoXiaoMi,

    '/privacy-moshengjiaoyou': MoShengJiaoYou,
    '/privacy-yumijiaoyou': YuMiJiaoYou,
    '/privacy-xunta': XunTa,
    '/privacy-xunta-mimi': XunTaMiMi
};


export default router;